// import { ipcRenderer } from 'electron'
// import isElectron from 'is-electron'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactModal from 'react-modal'
import ReactTooltip from 'react-tooltip'
import Select from 'react-simpler-select'
import classnames from 'classnames'

// import { asyncLocalStorage } from '../utilities/'

import LabeledInput from './UI/LabeledInput'

import tooltips from '../constants/tooltips.json'

import {
  setVelocityCurve,
  setPressureDisabledReturn,
  setTiltDisabledReturn,
  setOnThreshold,
  revertSettings,
  fetchFirmware,
  sendPreset,
  openPreferences,
  setMIDIThruPort,
  toggleTooltips
} from '../actions'

const curves = [
  'Linear',
  'Logarithmic',
  'Sine',
  'Cosine',
  'Exponential',
  'Invert'
]

var devFwVersion = '0.0.0';
var appVersion = '0.0.0';
var fwMatch = true;

class Preferences extends Component {
  
  static deviceFwVer() {
    return devFwVersion;
  }
  static appFwVer() {
    return appVersion;
  }
  static fwMatches() {
    return fwMatch;
  }

  componentDidMount() {
    /*
    if(isElectron()) {
      // set menu item
      asyncLocalStorage.getItem('k-board_editorPreferences').then(preferences => {
        ipcRenderer.send('menu-toggle-tooltips', {
          checked: JSON.parse(preferences).showTooltips
        });
      })
      // toggle preferences
      ipcRenderer.on('preferences', (event, value) => this.props.onTogglePreferences(value))
      // device
      ipcRenderer.on('firmware-update', () => this.props.onFetchFirmware(this.props.availableFirmware.url))
      ipcRenderer.on('send-preset', () => this.props.onSendPreset())
      // reverts
      ipcRenderer.on('revert-preset-defaults', () => this.props.onRevert('preset'))
      ipcRenderer.on('revert-sensitivities-defaults', () => this.props.onRevert('sensitivities'))
      ipcRenderer.on('revert-preferences-defaults', () => this.props.onRevert('preferences'))
      // tooltips
      ipcRenderer.on('toggle-tooltips', (event, value) => this.props.onToggleTooltips(value))
    }
    */
  }

  componentWillUnmount() {
    /*
    if(isElectron()) {
      ipcRenderer.removeAllListeners('preferences')
      // device
      ipcRenderer.removeAllListeners('firmware-update')
      ipcRenderer.removeAllListeners('send-preset')
      // reverts
      ipcRenderer.removeAllListeners('revert-preset-defaults')
      ipcRenderer.removeAllListeners('revert-sensitivities-defaults')
      ipcRenderer.removeAllListeners('revert-preferences-defaults')
      // tooltips
      ipcRenderer.removeAllListeners('toggle-tooltips')
    }
    */
  }

  afterOpenModal = () => {
    ReactTooltip.rebuild()
  }

  handleCloseModal = () => {
    this.props.onTogglePreferences(false)
  }

  render() {
    const {
      onSetVelocityCurve,
      onSetPressureDisabledReturn,
      onSetTiltDisabledReturn,
      onSetOnThreshold,
      onThreshold,
      onFetchFirmware,
      onToggleTooltips,
      onSetMIDIThruPort,
      networkConnection,
      deviceConnected,
      firmwareVersion,
      availableFirmware,
      editorVersion,
      bootloaderMode,
      updatingFirmware,
      velocityCurve,
      pressureDisabledReturn,
      tiltDisabledReturn,
      preferencesOpen,
      showTooltips
    } = this.props
    return (
      <ReactModal
        isOpen={preferencesOpen}
        className="react-modal"
        contentLabel="Preferences"
        onAfterOpen={this.afterOpenModal}
        onRequestClose={this.handleCloseModal}
        shouldCloseOnOverlayClick={true}
        overlayClassName="react-modal-overlay"
        parentSelector={() => document.querySelector('#root .editor')}
      >
        <div
          className={
            classnames(
              'preferences',
              // {'electron': isElectron()}
            )
          }>
          <h3>Preferences</h3>
          <label
            className="labeled-velocity-curve"
            data-tip={tooltips['velocity_curve']}
            data-multiline="true"
            data-place="bottom"
            data-tip-disable={!showTooltips}
          >
            Velocity Curve
            <Select
              name="velocity-curve"
              value={curves.indexOf(velocityCurve)}
              options={curves.map((item, index) => ({ label: item, value: index }))}
              onChange={(index) => {
                onSetVelocityCurve(curves[~~index])
              }}
            />
          </label>
          <LabeledInput
            tip={tooltips['pressure_disabled_return']}
            multiline="true"
            place="bottom"

            label="Pressure Disabled Return Value"
            min={-1} max={127}
            value={pressureDisabledReturn}
            onChange={onSetPressureDisabledReturn}
          />
          <LabeledInput
            tip={tooltips['tilt_disabled_return']}
            multiline="true"
            place="bottom"

            label="Tilt Disabled Return Value"
            min={-1} max={127}
            value={tiltDisabledReturn}
            onChange={onSetTiltDisabledReturn}
          />
          <LabeledInput
            tip={tooltips['on_threshold']}
            multiline="true"
            place="bottom"

            label="On Threshold"
            min={1} max={127}
            value={onThreshold}
            onChange={onSetOnThreshold}
          />
          <label
            className="labeled-item labeled-midi-thru"
            data-tip={tooltips['midi_thru']}
            data-multiline="true"
            data-place="bottom"
            data-tip-disable={!showTooltips}
          >
            MIDI THru
            <Select
              name="midi-thru"
              value={this.props.midithruport}
              options={window.midithruports || [{ value: 'none', label: 'None', disabled: false }]}
              onChange={(name) => {
                onSetMIDIThruPort(name)
                // set thru port on window
                window.kboardthru = window.midithruports.find(p => p.value === name).port
              }}
            />
          </label>
          <div
            className={classnames('labeled-item', 'label-button', 'tooltips')}
            data-tip={tooltips['tooltip_toggle']}
            data-multiline="true"
            data-place="bottom"
            data-tip-disable={!showTooltips}
          >
            <label>Tooltips</label>
            <button
              className={classnames('toggle-tooltips', { 'off': !showTooltips }, { 'on': showTooltips })}
              onClick={() => {
                /*
                if(isElectron()) {
                  ipcRenderer.send('menu-toggle-tooltips', {
                    checked: JSON.parse(preferences).showTooltips
                  });
                }
                */
                onToggleTooltips(showTooltips ? false : true)
              }}
            >{showTooltips ? 'On' : 'Off'}</button>
          </div>
          <div
            className={classnames('labeled-item', 'label-button', 'firmware', { 'disabled': (!deviceConnected && !bootloaderMode) || !networkConnection })}
            data-tip={tooltips['firmware_update']}
            data-multiline="true"
            data-place="bottom"
            data-tip-disable={!showTooltips}
          >
            <label>Update Firmware</label>
            <button
              className='update-firmware'
              disabled={
                ((!deviceConnected && !bootloaderMode) || !networkConnection)
                  || updatingFirmware
                  ? 'disabled' : ''
              }
              onClick={() => {
                onFetchFirmware(availableFirmware.url)
              }}
            >Update</button>
          </div>
          <div
            className="device-info"
            data-tip={tooltips['device_info']}
            data-multiline="true"
            data-place="top"
            data-tip-disable={!showTooltips}
          >
            <p className="editor-version">Editor Version: {editorVersion}</p><br />
            <p className="available-firmware-version">Available Firmware: {availableFirmware.version}</p>
            <p className="current-firmware-version">Current Firmware: {firmwareVersion}</p>
          </div>
          <button
            className="close"
            data-tip={tooltips['preferences_close']}
            data-multiline="true"
            data-place="top"
            data-tip-disable={!showTooltips}
            onClick={this.handleCloseModal}
          >Close</button>
        </div>
      </ReactModal>
    );
  }
}



const mapStateToProps = (state) => {


  fwMatch = (state.device.firmwareVersion === state.device.availableFirmware.version) ? true : false;
  appVersion = state.device.availableFirmware.version;
  devFwVersion = state.device.firmwareVersion;
  return {
    firmwareVersion: state.device.firmwareVersion,
    availableFirmware: state.device.availableFirmware,
    deviceConnected: state.device.connected,
    bootloaderMode: state.device.bootloaderMode,
    updatingFirmware: state.device.updatingFirmware,
    editorVersion: state.editor.editorVersion,
    networkConnection: state.editor.networkConnection,
    preferencesOpen: state.editor.preferencesOpen,
    midithruport: state.editor.midithruport,
    showTooltips: state.editorPreferences.showTooltips,
    velocityCurve: state.currentPreset.velocity_curve,
    pressureDisabledReturn: state.currentPreset.pressure_disabled_return,
    tiltDisabledReturn: state.currentPreset.tilt_disabled_return,
    onThreshold: state.currentPreset.on_thresh,
    mpeActive: state.currentPreset.mpe_active,
    mpeMemberChannels: state.currentPreset.mpe_member_channels
  }
}

const mapDispatchToProps = (dispatch) => {
  //console.log('EBBC mapDispatchToProps');
  return {
    onSetVelocityCurve: (curve) => {
      dispatch(setVelocityCurve(curve))
    },
    onSetPressureDisabledReturn: (value) => {
      dispatch(setPressureDisabledReturn(value))
    },
    onSetTiltDisabledReturn: (value) => {
      dispatch(setTiltDisabledReturn(value))
    },
    onSetOnThreshold: (threshold) => {
      dispatch(setOnThreshold(threshold))
    },
    onFetchFirmware: (url) => {
      dispatch(fetchFirmware(url))
    },
    onSendPreset: () => {
      dispatch(sendPreset())
    },
    onRevert: (type) => {
      dispatch(revertSettings(type))
    },
    onTogglePreferences: (action) => {
      dispatch(openPreferences(action))
    },
    onToggleTooltips: (active) => {
      dispatch(toggleTooltips(active))
    },
    onSetMIDIThruPort: (name) => {
      dispatch(setMIDIThruPort(name))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Preferences)
